(function () {
  function getThemeRoutes() {
    return (window.Theme && window.Theme.routes) || {};
  }

  function getMoneyFormat() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    return (root && root.getAttribute('data-money-format')) || '${{amount}}';
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount).replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getCardQty(card) {
    var input = card.querySelector('[data-cs-accessory-qty]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function setCardBusy(card, busy) {
    if (!card) return;
    card.classList.toggle('is-busy', !!busy);
    card.querySelectorAll('[data-cs-accessory-add-btn], [data-cs-accessory-qty], [data-cs-accessory-qty-minus], [data-cs-accessory-qty-plus], .cs-accessory-rec__variant-select').forEach(function (el) {
      if (busy) {
        el.setAttribute('disabled', 'disabled');
      } else if (!card.hasAttribute('data-cs-accessory-sold-out')) {
        el.removeAttribute('disabled');
      }
    });
  }

  function refreshEmpireCartCount() {
    var routes = getThemeRoutes();
    var cartUrl = routes.cart_url;
    if (!cartUrl) return Promise.resolve();

    return fetch(cartUrl + '.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        window.dispatchEvent(
          new CustomEvent('cartcount:update', {
            detail: cart
          })
        );
      })
      .catch(function () {});
  }

  function cartAddItems(items) {
    var routes = getThemeRoutes();
    var addUrl = routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json();
    });
  }

  function cartChangeLine(lineKey, quantity) {
    var routes = getThemeRoutes();
    var changeUrl = routes.cart_change_url ? routes.cart_change_url + '.js' : '/cart/change.js';
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (response) {
      return response.json();
    });
  }

  function findLineKeyInCart(cart, variantId) {
    if (!cart || !cart.items) return '';
    var targetId = parseInt(variantId, 10);
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === targetId) {
        return cart.items[i].key;
      }
    }
    return '';
  }

  function syncCardLineKey(card, variantId) {
    var routes = getThemeRoutes();
    if (!routes.cart_url) return Promise.resolve();
    return fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var key = findLineKeyInCart(cart, variantId);
        if (key) {
          card.setAttribute('data-cart-line-key', key);
        }
      })
      .catch(function () {});
  }

  function addAccessoryFromCard(card) {
    var idInput = card.querySelector('[data-accessory-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId) return Promise.resolve(false);

    var qty = getCardQty(card);
    setCardBusy(card, true);

    return cartAddItems([{ id: parseInt(variantId, 10), quantity: qty }])
      .then(function (response) {
        if (response.status || response.message === 'Cart Error') {
          window.alert(response.description || response.message || 'Could not add to cart');
          return false;
        }
        if (response.items && response.items.length) {
          for (var i = 0; i < response.items.length; i++) {
            if (response.items[i].variant_id === parseInt(variantId, 10)) {
              card.setAttribute('data-cart-line-key', response.items[i].key);
              break;
            }
          }
        } else {
          return syncCardLineKey(card, variantId).then(function () {
            return refreshEmpireCartCount().then(function () {
              return true;
            });
          });
        }
        return refreshEmpireCartCount().then(function () {
          return true;
        });
      })
      .catch(function () {
        window.alert('Could not add to cart');
        return false;
      })
      .finally(function () {
        setCardBusy(card, false);
      });
  }

  function addOrUpdateAccessoryFromCard(card) {
    var lineKey = card.getAttribute('data-cart-line-key');
    if (!lineKey) {
      return addAccessoryFromCard(card);
    }
    return updateAccessoryLineQty(card);
  }

  function updateAccessoryLineQty(card) {
    var lineKey = card.getAttribute('data-cart-line-key');
    if (!lineKey) {
      return Promise.resolve(false);
    }
    var qty = getCardQty(card);

    setCardBusy(card, true);
    return cartChangeLine(lineKey, qty)
      .then(function (response) {
        if (response.message === 'Cart Error' || response.status) {
          window.alert(response.description || response.message || 'Could not update cart');
          return false;
        }
        return refreshEmpireCartCount().then(function () {
          return true;
        });
      })
      .catch(function () {
        window.alert('Could not update cart');
        return false;
      })
      .finally(function () {
        setCardBusy(card, false);
      });
  }

  function showAddButtonFeedback(addBtn) {
    var root = addBtn.closest('[data-cs-accessory-recs]');
    var labelEl = addBtn.querySelector('[data-cs-accessory-add-label]') || addBtn.querySelector('span');
    if (!labelEl) return;

    var addLabel = (root && root.getAttribute('data-label-add')) || '+ Add';
    var addedLabel = (root && root.getAttribute('data-label-added')) || '√ Added';

    if (addBtn._addedFeedbackTimer) {
      window.clearTimeout(addBtn._addedFeedbackTimer);
      addBtn._addedFeedbackTimer = null;
    }

    labelEl.textContent = addedLabel;
    addBtn.classList.add('is-added');
    addBtn.setAttribute('disabled', 'disabled');

    addBtn._addedFeedbackTimer = window.setTimeout(function () {
      labelEl.textContent = addLabel;
      addBtn.classList.remove('is-added');
      addBtn._addedFeedbackTimer = null;
      if (!addBtn.closest('[data-cs-accessory-sold-out]')) {
        addBtn.removeAttribute('disabled');
      }
    }, 2000);
  }

  function openAccessoryRecSelect(select) {
    if (!select) return;
    try {
      if (typeof select.showPicker === 'function') {
        select.showPicker();
        return;
      }
    } catch (err) {}
    select.focus({ preventScroll: true });
    select.click();
  }

  function initAccessoryRecVariantPickers() {
    document.querySelectorAll('.cs-accessory-rec__variant-chevron').forEach(function (chevron) {
      chevron.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var label = chevron.closest('label.cs-accessory-rec__variant');
        openAccessoryRecSelect(label && label.querySelector('select'));
      });
      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    document.querySelectorAll('label.cs-accessory-rec__variant').forEach(function (label) {
      label.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.target.classList.contains('cs-accessory-rec__variant-chevron')) return;
        e.preventDefault();
        openAccessoryRecSelect(label.querySelector('select'));
      });
    });
  }

  function updateAccessoryRecCard(selectEl) {
    var card = selectEl.closest('.cs-accessory-rec__card');
    if (!card) return;

    var option = selectEl.options[selectEl.selectedIndex];
    var variantId = selectEl.value;
    var price = option.getAttribute('data-price');
    var compareAt = option.getAttribute('data-compare-at');
    var idInput = card.querySelector('[data-accessory-variant-id]');
    var oldLineKey = card.getAttribute('data-cart-line-key');

    if (idInput) idInput.value = variantId;

    var imageUrl = option.getAttribute('data-image');
    var recImage = card.querySelector('[data-cs-accessory-rec-image]');
    if (recImage && imageUrl) {
      recImage.src = imageUrl;
      recImage.srcset = '';
    }

    var priceWrap = card.querySelector('[data-cs-accessory-rec-price] .cs-accessory-rec__price-line');
    if (priceWrap && price) {
      var html = '<ins><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(price, 10)) + '</span></ins>';
      if (compareAt && parseInt(compareAt, 10) > parseInt(price, 10)) {
        html += '<del><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(compareAt, 10)) + '</span></del>';
      }
      priceWrap.innerHTML = html;
    }

    var addBtn = card.querySelector('[data-cs-accessory-add-btn]');

    if (option.disabled) {
      card.setAttribute('data-cs-accessory-sold-out', '');
      if (addBtn) addBtn.setAttribute('disabled', 'disabled');
      card.querySelectorAll('[data-cs-accessory-qty], [data-cs-accessory-qty-minus], [data-cs-accessory-qty-plus]').forEach(function (el) {
        el.setAttribute('disabled', 'disabled');
      });
    } else {
      card.removeAttribute('data-cs-accessory-sold-out');
      if (addBtn) addBtn.removeAttribute('disabled');
      card.querySelectorAll('[data-cs-accessory-qty], [data-cs-accessory-qty-minus], [data-cs-accessory-qty-plus]').forEach(function (el) {
        el.removeAttribute('disabled');
      });
    }

    if (oldLineKey) {
      card.removeAttribute('data-cart-line-key');
      cartChangeLine(oldLineKey, 0).finally(function () {
        addAccessoryFromCard(card);
      });
    }
  }

  function handleQtyMinus(e) {
    var card = e.currentTarget.closest('[data-cs-accessory-card]');
    var input = card && card.querySelector('[data-cs-accessory-qty]');
    if (!input || !card.getAttribute('data-cart-line-key')) return;
    var next = Math.max(1, parseInt(input.value, 10) - 1 || 1);
    input.value = String(next);
    updateAccessoryLineQty(card);
  }

  function handleQtyPlus(e) {
    var card = e.currentTarget.closest('[data-cs-accessory-card]');
    var input = card && card.querySelector('[data-cs-accessory-qty]');
    if (!input) return;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
    input.value = String(next);
    if (card.getAttribute('data-cart-line-key')) {
      updateAccessoryLineQty(card);
    }
  }

  function handleAccessoryRecAddClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var addBtn = e.currentTarget;
    if (addBtn.disabled) return;

    var card = addBtn.closest('[data-cs-accessory-card]');
    if (!card) return;

    addBtn.classList.add('is-loading');
    addOrUpdateAccessoryFromCard(card)
      .then(function (success) {
        if (success) {
          showAddButtonFeedback(addBtn);
        }
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
      });
  }

  function handleQtyInputChange(e) {
    var input = e.currentTarget;
    var card = input.closest('[data-cs-accessory-card]');
    if (!card || !card.getAttribute('data-cart-line-key')) return;
    var qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty < 1) {
      input.value = '1';
    }
    updateAccessoryLineQty(card);
  }

  function initAccessoryRecCarousel(root) {
    var track = root.querySelector('[data-cs-accessory-track]');
    var slides = track ? track.querySelectorAll('[data-cs-accessory-slide]') : [];
    var prevBtn = root.querySelector('[data-cs-accessory-prev]');
    var nextBtn = root.querySelector('[data-cs-accessory-next]');
    var nav = root.querySelector('[data-cs-accessory-nav]');

    if (!track || !slides.length) return;

    if (slides.length <= 1) {
      if (nav) nav.setAttribute('hidden', 'hidden');
      track.style.transform = '';
      return;
    }

    if (nav) nav.removeAttribute('hidden');

    var index = 0;

    function updateCarousel() {
      track.style.transform = 'translate3d(' + -index * 100 + '%, 0, 0)';
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          updateCarousel();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (index < slides.length - 1) {
          index += 1;
          updateCarousel();
        }
      });
    }

    updateCarousel();
  }

  function initAccessoryRecommendations() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    if (!root) return;

    if (root.getAttribute('data-cs-bound') === '1') return;
    root.setAttribute('data-cs-bound', '1');

    initAccessoryRecCarousel(root);

    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        updateAccessoryRecCard(selectEl);
      });
    });

    document.querySelectorAll('[data-cs-accessory-add-btn]').forEach(function (btn) {
      btn.addEventListener('click', handleAccessoryRecAddClick);
    });

    document.querySelectorAll('[data-cs-accessory-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', handleQtyMinus);
    });

    document.querySelectorAll('[data-cs-accessory-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', handleQtyPlus);
    });

    document.querySelectorAll('[data-cs-accessory-qty]').forEach(function (input) {
      input.addEventListener('change', handleQtyInputChange);
      input.addEventListener('blur', handleQtyInputChange);
    });

    initAccessoryRecVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessoryRecommendations);
  } else {
    initAccessoryRecommendations();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('[data-cs-accessory-card]').forEach(function (card) {
        card.removeAttribute('data-cart-line-key');
      });
    }
  });
})();
